"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const component_text_1 = require("@patternplate/component-text");
const Styles = require("./toggle-head.styles");
exports.ToggleHead = function ToggleHead(props) {
    const query = { [`${props.name}-enabled`]: !props.enabled };
    return (React.createElement(Styles.StyledToggleHead, { query: query, className: props.className, title: `${props.enabled ? "Hide" : "Show"} ${props.name}` },
        React.createElement(component_text_1.Text, null, props.children),
        React.createElement(Styles.StyledArrow, { rotated: props.enabled }, "\u25BC")));
};
//# sourceMappingURL=toggle-head.js.map